import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

import { InvitationStatusType } from '@vi-iot/client';

import {
  ActiveInvitationsFilterType,
  AuthStore,
  InvitationsStore,
  NewInvitationStore,
  RemoteConfigStore,
} from '@store';

import { filter, Subject, take, takeUntil } from 'rxjs';
import { AdditionalServicesComponent } from 'src/app/+booking/booking-plans/additional-services/additional-services.component';
import { NewInvitationComponent } from '../invitations/new-invitation/new-invitation.component';
import { InvitationsService } from '../service/invitations.service';

@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationsComponent implements OnInit, OnDestroy {
  ActiveInvitationsFilterType = ActiveInvitationsFilterType;
  newInvitationModalRef: MatDialogRef<NewInvitationComponent>;
  private dialogConfig = new MatDialogConfig();
  private isGermanUser: boolean;
  private ngUnsubscribe$ = new Subject<void>();
  constructor(
    public remoteConfigStore: RemoteConfigStore,
    public invitationsStore: InvitationsStore,
    public authStore: AuthStore,
    private newInvitationStore: NewInvitationStore,
    private matDialog: MatDialog,
    private invitationServices: InvitationsService
  ) {}

  ngOnInit(): void {
    this.invitationsStore.bulkListInvitations();
    this.authStore.isCompanyFromGermany$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isCompanyFromGermany) => {
        this.isGermanUser = isCompanyFromGermany;
      });
  }

  filterInvitations(filter: ActiveInvitationsFilterType): void {
    this.invitationsStore.filterInvitations(filter);
  }

  onAccept(event: { token: string; ownerName: string }): void {
    this.invitationsStore.updateInvitation(
      event.token,
      InvitationStatusType.Accepted,
      event.ownerName
    );
    this.invitationServices.invitationAccepted$
      .pipe(
        filter((token) => token === event.token),
        take(1),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe(() => {
        if (this.isGermanUser) {
          this.dialogConfig.maxHeight = '90vh';
          this.dialogConfig.data = {
            popupTitle: '+ADDITIONAL.SERVICE.FEATURE.SUCCESSFULLY_CONFIRM_SERVICE',
          };
          this.matDialog.open(AdditionalServicesComponent, this.dialogConfig);
        }
      });
  }

  onReject(event: { token: string; ownerName: string }): void {
    this.invitationsStore.updateInvitation(
      event.token,
      InvitationStatusType.Rejected,
      event.ownerName
    );
  }

  onCancel(event: { token: string }): void {
    this.invitationsStore.updateInvitation(event.token, InvitationStatusType.Canceled);
  }

  /** Open new inviatation modal */

  onNewInvitation(): void {
    this.newInvitationStore.createInvitationInit();
    this.newInvitationModalRef = this.matDialog.open(NewInvitationComponent, {
      width: '552px',
      panelClass: 'new-invitation-modal',
      disableClose: true,
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
